import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { NEW_MECHANIC_PATH, MECHANIC_PATH } from '../../../../config/paths';
import {
  getMechanics,
  clearMechanics,
} from '../../../../actions/mechanical-maintenance';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { MECHANIC_COLUMNS } from '../../../../config/columns';

export const Mechanics = ({
  breadcrumbs,
  mechanics,
  loading,
  dispatchGetMechanics,
  dispatchClearMechanics,
}) => {
  useLayoutEffect(() => () => dispatchClearMechanics(), []);

  const data = mechanics.get('content') || [];
  const pages = mechanics.get('totalPages') || null;
  const defaultPageSize = mechanics.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Lista de Personal"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_MECHANIC_PATH}
      tableStructure={{
        columns: MECHANIC_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetMechanics,
        modelPath: MECHANIC_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetMechanics: getMechanics,
  dispatchClearMechanics: clearMechanics,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  breadcrumbs: [
    ...MechanicalMaintenanceUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Personal',
      href: MECHANIC_PATH,
    },
  ],
  mechanics: MechanicalMaintenanceUnit.Mechanic.getIn(['all', 'content']),
  loading: MechanicalMaintenanceUnit.Mechanic.getIn(['all', 'loading']),
});

Mechanics.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  mechanics: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetMechanics: PropTypes.func.isRequired,
  dispatchClearMechanics: PropTypes.func.isRequired,
};

Mechanics.defaultProps = {
  mechanics: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Mechanics);
